import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { ABTEST_PAYMENT_PAGE_CTA_ALWAYS_ACTIVE } from '@monofront/business/constants';
import { ABTEST_CHECKOUT_PAYMENT_CTA_FROM_STICKY_INTO_SUMMARY } from '@monofront/business/constants';
import { useTranslations } from 'next-intl';
import { toast } from 'react-toastify';

/**
 * Display a disabled Pay CTA
 */
const PayCtaDisabled: React.FC = () => {
  const tCheckout = useTranslations('Checkout');
  const isPaymentPageCtaAlwaysActiveABTestEnabled = useFeatureIsOn(
    ABTEST_PAYMENT_PAGE_CTA_ALWAYS_ACTIVE,
  );
  const isPaymentCTAFromStickyIntoSummaryAbTestEnabled = useFeatureIsOn(
    ABTEST_CHECKOUT_PAYMENT_CTA_FROM_STICKY_INTO_SUMMARY,
  );

  return (
    <button
      disabled={isPaymentPageCtaAlwaysActiveABTestEnabled ? false : true}
      className="tw-lf-button tw-lf-button-primary tw-lf-button-md tw-w-full"
      data-testid={`Pay-Cta-Disabled`}
      onClick={
        isPaymentPageCtaAlwaysActiveABTestEnabled ||
        isPaymentCTAFromStickyIntoSummaryAbTestEnabled
          ? () => {
              toast.error(tCheckout('selectPaymentMethodError'));
            }
          : undefined
      }
    >
      {tCheckout('finishCheckout')}
    </button>
  );
};

export default PayCtaDisabled;
